import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { reducer as formReducer } from "redux-form";
import isLoading from "./reducers/ui/ui";


const rootReducer = combineReducers({
  ui: isLoading,
  form: formReducer,
});

let composeEnhancers = compose;

const configureStore = () => {
  return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js